import { Icon } from "@nexus/ui";
import { useTranslation } from "react-i18next";

export interface PersonaOpportunityEmptyPersonaStateProps {
  /** While the set is still generating, avoid implying this persona finished with zero angles. */
  isGenerating?: boolean;
}

/** Shown when a persona is attached to the set but the angle query returned no rows. */
export function PersonaOpportunityEmptyPersonaState({
  isGenerating = false,
}: PersonaOpportunityEmptyPersonaStateProps) {
  const { t } = useTranslation();

  if (isGenerating) {
    return (
      <p
        role="status"
        className="flex items-center justify-center gap-2 rounded-md border border-dashed border-border bg-muted/20 px-4 py-6 text-center text-sm text-muted-foreground"
      >
        <Icon name="loader" size="sm" className="animate-spin text-primary" />
        {t(
          "personaOpportunities.active.generatingOpportunitiesForPersona",
          "Generating opportunities for this persona…",
        )}
      </p>
    );
  }

  return (
    <p className="rounded-md border border-dashed border-border bg-muted/20 px-4 py-6 text-center text-sm text-muted-foreground">
      {t(
        "personaOpportunities.active.noOpportunitiesForPersona",
        "No opportunities found for this persona.",
      )}
    </p>
  );
}
